import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  DEFAULT_SITE_META,
  OG_IMAGE,
  getOgImageUrl,
  getPageMeta,
  getSiteUrl,
} from '../../config/siteMeta';

const setMetaTag = (
  attribute: 'name' | 'property',
  key: string,
  content: string,
) => {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const { title, description } = getPageMeta(pathname);
    const siteUrl = getSiteUrl(window.location.origin);
    const canonicalUrl = `${siteUrl}${pathname === '/' ? '' : pathname}`;
    const ogImageUrl = getOgImageUrl();

    document.title = title;

    setMetaTag('name', 'description', description);
    setMetaTag('name', 'keywords', DEFAULT_SITE_META.keywords);

    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:site_name', DEFAULT_SITE_META.siteName);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', canonicalUrl);
    setMetaTag('property', 'og:image', ogImageUrl);
    setMetaTag('property', 'og:image:secure_url', ogImageUrl);
    setMetaTag('property', 'og:image:width', String(OG_IMAGE.width));
    setMetaTag('property', 'og:image:height', String(OG_IMAGE.height));
    setMetaTag('property', 'og:image:type', OG_IMAGE.type);
    setMetaTag('property', 'og:image:alt', OG_IMAGE.alt);
    setMetaTag('property', 'og:locale', DEFAULT_SITE_META.locale);

    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', ogImageUrl);
    setMetaTag('name', 'twitter:image:alt', OG_IMAGE.alt);

    let canonicalLink = document.head.querySelector(
      'link[rel="canonical"]',
    ) as HTMLLinkElement | null;

    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    canonicalLink.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
};

export default PageMeta;
